import template from './linkTypeChoice.html';
import controller from './linkTypeChoice.controller';
import './linkTypeChoice.scss';

let linkTypeChoiceComponent = {
  restrict: 'E',
  bindings: {
    label: '@',
    advert: '=',
    linkValues: '=',
    linkTypes: '<',
    racedays: '<',
    locations: '<',
    nonRacingEvents: '<',
    validationError: '<'
  },
  template,
  controller
};

export default linkTypeChoiceComponent;
